import { ɵɵdefineInjectable, Injectable, Component, forwardRef, Input, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgxStarRatingService = /** @class */ (function () {
    function NgxStarRatingService() {
    }
    NgxStarRatingService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    NgxStarRatingService.ctorParameters = function () { return []; };
    /** @nocollapse */ NgxStarRatingService.ngInjectableDef = ɵɵdefineInjectable({ factory: function NgxStarRatingService_Factory() { return new NgxStarRatingService(); }, token: NgxStarRatingService, providedIn: "root" });
    return NgxStarRatingService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgxStarRatingComponent = /** @class */ (function () {
    function NgxStarRatingComponent() {
        this.stars = [5, 4, 3, 2, 1];
        this.propagateChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        if (!this.disabled) {
            this.disabled = false;
        }
    }
    /**
     * @return {?}
     */
    NgxStarRatingComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @param {?} rate
     * @return {?}
     */
    NgxStarRatingComponent.prototype.rate = /**
     * @param {?} rate
     * @return {?}
     */
    function (rate) {
        if (!this.disabled) {
            this.propagateChange(rate);
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NgxStarRatingComponent.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.value = value;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NgxStarRatingComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.propagateChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NgxStarRatingComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) { };
    NgxStarRatingComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ngx-star-rating',
                    template: "<form action=\"\">\n  <ng-template ngFor let-star [ngForOf]=\"stars\" let-currentElementIndex=\"(index + 1)\">\n    <input class=\"star star-{{ star }}\" id=\"star-{{ star }}-{{ id }}\" type=\"radio\" name=\"star\" (click)=\"rate(star)\"\n      [checked]=\"value == star\" [disabled]=\"disabled\" />\n    <label class=\"star star-{{ star }}\" for=\"star-{{ star }}-{{ id }}\"></label>\n  </ng-template>\n</form>\n",
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return NgxStarRatingComponent; })),
                            multi: true,
                        }
                    ],
                    styles: ["@charset \"UTF-8\";*{margin:0;padding:0;font-family:roboto}body{background:#000}.cont{width:93%;max-width:350px;text-align:center;margin:4% auto;padding:30px 0;background:#111;color:#eee;border-radius:5px;border:thin solid #444;overflow:hidden}hr{margin:20px;border:none;border-bottom:thin solid rgba(255,255,255,.1)}div.title{font-size:2em}h1 span{font-weight:300;color:#fd4}div.stars{width:270px;display:inline-block}input.star{display:none}label.star{float:right;padding:10px;font-size:36px;color:#444;transition:.2s}input.star:checked~label.star:before{content:\"\uF005\";color:#fd4;transition:.25s}input.star-5:checked~label.star:before{color:#fe7;text-shadow:0 0 20px #952}input.star-1:checked~label.star:before{color:#f62}label.star:hover{-webkit-transform:rotate(-15deg) scale(1.3);transform:rotate(-15deg) scale(1.3)}label.star:before{content:\"\uF006\";font-family:FontAwesome}"]
                }] }
    ];
    /** @nocollapse */
    NgxStarRatingComponent.ctorParameters = function () { return []; };
    NgxStarRatingComponent.propDecorators = {
        id: [{ type: Input }],
        disabled: [{ type: Input }]
    };
    return NgxStarRatingComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgxStarRatingModule = /** @class */ (function () {
    function NgxStarRatingModule() {
    }
    NgxStarRatingModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [NgxStarRatingComponent],
                    imports: [
                        CommonModule
                    ],
                    exports: [NgxStarRatingComponent]
                },] }
    ];
    return NgxStarRatingModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgxStarRatingComponent, NgxStarRatingModule, NgxStarRatingService };
//# sourceMappingURL=ngx-star-rating.js.map
